// Local browser session cache — auto-persists the current design so an accidental
// refresh or browser close can be resumed, no account required. This is INDEPENDENT of
// the explicit "Save Scenario" / cloud-autosave features; it is a lightweight local cache.
const KEY = "dsymbia:session:v1";

// Persist design data only. The uploaded .3dm geometry (Base64) is intentionally dropped —
// it is too large for localStorage and lives in the 3D engine (user re-uploads on resume).
export function saveSession(project) {
  try {
    if (!project) return;
    const light = { ...project, model: null, cachedAt: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(light));
  } catch {
    /* storage disabled or quota exceeded — cache is best-effort, ignore */
  }
}

export function loadSession() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

// Only worth offering "Resume" when the cache holds real design work.
export function hasMeaningfulSession(data) {
  const st = data?.state;
  if (!st) return false;
  const sel = st.selections || {};
  const selCount =
    (sel.locations?.length || 0) +
    (sel.systems?.length || 0) +
    (sel.crops?.length || 0) +
    (sel.resources?.length || 0);
  return !!(st.geo || st.systemBlocks?.length || selCount > 0);
}

// A short human label for the banner, e.g. "Toronto, CA · 3 systems".
export function sessionSummary(data) {
  const st = data?.state || {};
  const place = st.geo?.name || "Untitled site";
  const n = st.systemBlocks?.length || 0;
  return n > 0 ? `${place} · ${n} system${n === 1 ? "" : "s"}` : place;
}
